export class Global {
  //baseUrl = "http://localhost:57756/api/"; // LOCAL URL
  //baseUrl = "http://speedapi.courierpro.co.in/api/";
  baseUrl = 'http://webapi.speediexpress.com/api/'; // LIVE URL
}
